import React from 'react';
import { Link } from 'react-router-dom';
import { ACCENT } from '../utils/dashboardUtils';

export const panelStyle = {
    backgroundColor: '#FFFFFF',
    border: '1px solid #EAECF0',
    borderRadius: '1rem',
    boxShadow: '0 1px 2px rgba(16,24,40,0.04)'
};

export const PanelLink = ({ to, label }) => (
    <Link to={to} className="no-underline text-sm font-semibold flex align-items-center gap-2" style={{ color: ACCENT }}>
        {label}
        <i className="pi pi-arrow-right" style={{ fontSize: '0.75rem' }} />
    </Link>
);

const DashboardPanel = ({ title, action, children, className = '', style }) => (
    <div className={`p-4 w-full flex flex-column ${className}`.trim()} style={{ ...panelStyle, ...style }}>
        {(title || action) && (
            <div className="flex align-items-center justify-content-between gap-3 mb-3 flex-wrap">
                <h2 className="m-0 font-bold" style={{ fontSize: '1.05rem', color: '#101828', letterSpacing: '0.02em', textTransform: 'uppercase' }}>
                    {title}
                </h2>
                {action}
            </div>
        )}
        {children}
    </div>
);

export default DashboardPanel;
